export default "__VITE_ASSET__DRQuqx37__"